import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAxL97G2aD-_5hu54XscX5zZeZcLlyXt9c",
  authDomain: "tradefix-935b5.firebaseapp.com",
  projectId: "tradefix-935b5",
  storageBucket: "tradefix-935b5.firebasestorage.app",
  messagingSenderId: "639062559445",
  appId: "1:639062559445:web:3067b4dad484ab061db05c",
  measurementId: "G-G4JX8LXL9H"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export default app;
